export default {
    title: 'Something went wrong',
    description: 'Legal Tune Up has encountered an error. Please try again',
    startOverBtn: 'Start Over',
};
